/**
 * Erişim yönetimi (kontrollü erişim) — admin panel API'si. Faz 5, Plan 05-05.
 *
 * Uçlar `services/data-service/routes/feature_access_routes.py` (05-04) ile
 * birebir: `/api/data/admin/feature-access/...`. İstemci yalnız kolaylıktır;
 * yetki ve doğrulama sunucudadır.
 */
import { apiFetch } from '@/lib/api-client'
import { extractExtensionApiErrorMessage } from '@/services/extension-features-api'

const ADMIN_BASE_URL = '/api/data/admin'

/** Hata çıkarıcı tek kaynaktan (kopyalama yok). */
export { extractExtensionApiErrorMessage }

export const DASHBOARD_HOME_FEATURE = 'dashboard_home'
/** FBA sevkiyat takibi paneli (#973): migration 138 tohumu (yalnız adminler); sunucu anahtarı aynıdır. */
export const DASHBOARD_SHIPMENTS_FEATURE = 'dashboard_shipments'
/** Yeni ana ekranın Amazon hesabı bağlı SATICI paneli (satış/kâr/stok/iade): migration 145 tohumu (yalnız adminler); sunucu anahtarı aynıdır. */
export const DASHBOARD_SELLER_PANEL_FEATURE = 'dashboard_seller_panel'
export const LISTING_BUILDER_V2_FEATURE = 'listing_builder_v2'

/** Listing Builder AI sohbeti (Faz 2): migration 120 tohumu; sunucu anahtarı aynıdır. */
export const LISTING_BUILDER_AI_FEATURE = 'listing_builder_ai'

/** Listing Builder görselleri (Faz 5): migration 131 tohumu; sunucu anahtarı aynıdır. AI anahtarından bağımsızdır. */
export const LISTING_BUILDER_IMAGES_FEATURE = 'listing_builder_images'

/** Listing Builder rakipleri (Faz 6): migration 134 tohumu; sunucu anahtarı aynıdır. AI ve görsel anahtarlarından bağımsızdır. */
export const LISTING_BUILDER_COMPETITORS_FEATURE = 'listing_builder_competitors'

/** Blog lansman anahtarı (BLG-05, #874): migration 122 tohumu; sunucu anahtarı aynıdır. Kişi bazlı açma YOK. */
export const BLOG_FEATURE = 'blog'

/** Ödeme ön ekranı onay kutusu (#842): sunucu anahtarı aynıdır. Kişi bazlı açma YOK. */
export const CHECKOUT_TERMS_CLICKWRAP_FEATURE = 'checkout_terms_clickwrap'

/** Amazon P&L "Gelir & Gider" sekmesi ve kırılımdaki "Kendi kalemlerin" grubu (#814): migration 129 tohumu; sunucu anahtarı aynıdır. */
export const CUSTOM_CASH_ITEMS_FEATURE = 'custom_cash_items'

/** Ayarlar'daki hesap silme talebi bölümü (#907): migration 128 tohumu; sunucu anahtarı aynıdır. */
export const ACCOUNT_DELETION_REQUEST_FEATURE = 'account_deletion_request'

/** Ödeme sorunu uyarısı (#981): yan menü kartı + eklenti; migration 141 tohumu; sunucu anahtarı aynıdır. */
export const PAYMENT_ISSUE_NOTICE_FEATURE = 'payment_issue_notice'

/** Destek sohbeti (#1016): Chatwoot sohbet penceresi + eklenti bildirimi ticket'i; migration 149 tohumu; sunucu anahtarı aynıdır. */
export const SUPPORT_CHAT_FEATURE = 'support_chat'

/** Reklam bağlantısı koptu uyarısı (#1132): Ayarlar rozeti + dashboard kartı; migration 150 tohumu; sunucu anahtarı aynıdır. */
export const ADS_REAUTH_NOTICE_FEATURE = 'ads_reauth_notice'

/** DeepSearch filtrelerinde Tarih bölümü gizli (#1104, S412): anahtar açık olan Tarih bölümünü görmez; migration 155 tohumu; sunucu anahtarı aynıdır. */
export const DEEPSEARCH_HIDE_DATE_FILTER_FEATURE = 'deepsearch_hide_date_filter'
/** Reklam sayfasında Kanada/Meksika pazar seçici (#888); migration 143 tohumu; sunucu anahtarı aynıdır. */
export const ADS_MULTI_MARKETPLACE_FEATURE = 'ads_multi_marketplace'

/** Kai: deneyim sorusu ve profile göre yorum kuralı (#1079); migration 151 tohumu; sunucu anahtarı aynıdır. */
export const KAI_PROFILE_SCOPE_FEATURE = 'kai_profile_scope'
/** Rank Tracker'da Avustralya pazarı (#1095): seçicide AU + sunucuda AU ile ürün/kelime ekleme; migration 159 tohumu; sunucu anahtarı aynıdır. */
export const RANK_TRACKER_MARKETPLACE_AU_FEATURE = 'rank_tracker_marketplace_au'
/** Ana ekranda serbest tarih aralığı (#952): dönem seçiciye "Özel aralık"; migration 166 tohumu; sunucu anahtarı aynıdır. */
export const DASHBOARD_CUSTOM_RANGE_FEATURE = 'dashboard_custom_range'
/** Okunur yazı renkleri (#920/#955/#1198/#1401): iki temada soluk gri yazıların okunur tonu; <html data-contrast-admin> bu anahtar açıkken konur; migration 171 tohumu. */
export const READABLE_CONTRAST_FEATURE = 'readable_contrast'
/** Favori listesi "Günlük satış": grafikle aynı son gün değeri (#1404); migration 172 tohumu. Kapalıyken bugünkü 7 günlük ortalama. */
export const FAVORITES_LAST_DAY_SALES_FEATURE = 'favorites_last_day_sales'

/** Kai: dört parçalı cevap derinliği ve sayı denetimi (#1170); migration 156 tohumu; sunucu anahtarı aynıdır. */
export const KAI_ANSWER_DEPTH_FEATURE = 'kai_answer_depth'

/** Kai: kelime bilgisi aracı, skorsuz piyasa bilgisi (#1369); migration 166 tohumu; sunucu anahtarı aynıdır. */
export const KAI_TERM_INFO_FEATURE = 'kai_term_info'

/** Kai: aday ürün arama aracı, filtrelere uyan ürün listesi (#1170); migration 169 tohumu; sunucu anahtarı aynıdır. */
export const KAI_PRODUCT_SEARCH_FEATURE = 'kai_product_search'

/** Kai: ürün satış tahmini aracı, bir ürünün (ASIN) aylık satışı (#1385); migration 167 tohumu; sunucu anahtarı aynıdır. */
export const KAI_SALES_ESTIMATE_FEATURE = 'kai_sales_estimate'

/** Kai kullanım hakkı sınırı: plana göre günlük/aylık tur sayacı (#1170); migration 170 tohumu; sunucu anahtarı aynıdır. */
export const KAI_USAGE_LIMIT_FEATURE = 'kai_usage_limit'

/** Kai /save yer imi komutu: yalnız yönetici, sohbette "/save <not>" yazarak konuşmayı yer imi olarak saklar; migration 174 tohumu; sunucu anahtarı aynıdır. */
export const KAI_BOOKMARK_FEATURE = 'kai_bookmark'

/** Kai ASIN analizi: yalnız yönetici, Kai'ye bir ASIN verilince ürünün kimliği, satış/fiyat geçmişi ve diğer verileri tek araçla (urun_analizi) birleştirilip yanıtlanır; sunucu anahtarı aynıdır. */
export const KAI_ASIN_ANALYSIS_FEATURE = 'kai_asin_analysis'

/** Amazon P&L "Verileriniz hazırlanıyor" paneli (#1118): ilk aktarım sürerken kaynak durumu; sunucu anahtarı aynıdır. */
export const DATA_READINESS_PANEL_FEATURE = 'data_readiness_panel'

/** Listing Builder taslak kartı bekleme göstergesi (#1234): anahtar açık olan, ilk alan verisi gelene kadar ilk satırın `Hazırlanıyor` yazıldığını görür; migration 161 tohumu; sunucu anahtarı aynıdır. */
export const LISTING_BUILDER_DRAFT_WAIT_FEATURE = 'listing_builder_draft_wait'
/** Listing Builder arama sonucu önizlemesi doldurma (#306): Rakip sekmesindeki "Hedef arama"nın getirdiği gerçek ürün kartları; rakip anahtarının YANINDA ayrı anahtar (ikisi de açık olmalı); migration 163 tohumu (yalnız adminler); sunucu anahtarı aynıdır. */
export const LISTING_BUILDER_PREVIEW_FILL_FEATURE = 'listing_builder_preview_fill'
/** Listing Builder otomatik anahtar kelime ve rakip (#1416): hedef aramadan önemli kelime listesi, ürün tanımından hedef arama, rakip tamamlama; migration 173 tohumu (yalnız adminler); sunucu anahtarı aynıdır. */
export const LISTING_BUILDER_AUTO_DISCOVERY_FEATURE = 'listing_builder_auto_discovery'
/** Telefondan girene "bilgisayardan girin" şeridi (#1154, S450/S454): anahtar açık olan, dar + dokunmatik görünümde uygulamanın üstünde kapatılabilir şeridi görür; migration 162 tohumu (yalnız adminler); sunucu anahtarı aynıdır. */
export const MOBILE_DESKTOP_NOTICE_FEATURE = 'mobile_desktop_notice'
/** Avustralya (FE bölgesi) satıcı bağlantısı (#1096): bağlama ekranındaki Avustralya kartı + Amazon P&L'de AU; migration 158 tohumu (yalnız adminler); sunucu anahtarı aynıdır. */
export const AU_SELLER_CONNECTION_FEATURE = 'amazon_au_seller_connection'

/** Not: eklenti anahtarının 3'lü `FeatureAudience` tipinden AYRIDIR. */
export type FeatureAccessAudience = 'off' | 'admins' | 'selected' | 'all'
export type FeatureAccessOutsiderView = 'hidden' | 'coming_soon'
export type FeatureAccessKind = 'page' | 'card' | 'extension'

export interface FeatureAccessGrantedUser {
  user_id: string
  email: string | null
  updated_at: string | null
  updated_by: string | null
}

export interface FeatureAccessConfig {
  feature_key: string
  kind: FeatureAccessKind
  label: string
  audience: FeatureAccessAudience
  outsider_view: FeatureAccessOutsiderView
  updated_at: string | null
  updated_by: string | null
  granted_count: number
  granted_users: FeatureAccessGrantedUser[]
}

export interface UserFeatureAccess {
  feature_key: string
  user_id: string
  enabled: boolean
  updated_at: string | null
  updated_by: string | null
  email?: string | null
}

export const FEATURE_ACCESS_AUDIENCE_LABELS: Record<FeatureAccessAudience, string> = {
  off: 'Kapalı',
  admins: 'Yalnız adminler',
  selected: 'Seçilenler',
  all: 'Herkes',
}

export const FEATURE_ACCESS_OUTSIDER_VIEW_LABELS: Record<FeatureAccessOutsiderView, string> = {
  hidden: 'Eski ekran',
  coming_soon: 'Çok yakında',
}

interface ApiResponse<T> {
  success: boolean
  data: T
}

export function featureAccessQueryKey(featureKey: string) {
  return ['admin', 'feature-access', featureKey] as const
}

export function userFeatureAccessQueryKey(featureKey: string, userId: string) {
  return ['admin', 'feature-access', featureKey, 'user', userId] as const
}

function featurePath(featureKey: string): string {
  return `/feature-access/${encodeURIComponent(featureKey)}`
}

function userPath(featureKey: string, userId: string): string {
  return `${featurePath(featureKey)}/users/${encodeURIComponent(userId)}`
}

export async function fetchFeatureAccess(featureKey: string): Promise<FeatureAccessConfig> {
  const res = await apiFetch<ApiResponse<FeatureAccessConfig>>(featurePath(featureKey), {
    baseUrl: ADMIN_BASE_URL,
  })
  return res.data
}

export async function updateFeatureAccessAudience(
  featureKey: string,
  audience: FeatureAccessAudience,
): Promise<FeatureAccessConfig> {
  const res = await apiFetch<ApiResponse<FeatureAccessConfig>>(featurePath(featureKey), {
    baseUrl: ADMIN_BASE_URL,
    method: 'PUT',
    body: JSON.stringify({ audience }),
  })
  return res.data
}

export async function updateFeatureAccessOutsiderView(
  featureKey: string,
  outsiderView: FeatureAccessOutsiderView,
): Promise<FeatureAccessConfig> {
  const res = await apiFetch<ApiResponse<FeatureAccessConfig>>(featurePath(featureKey), {
    baseUrl: ADMIN_BASE_URL,
    method: 'PUT',
    body: JSON.stringify({ outsider_view: outsiderView }),
  })
  return res.data
}

export async function fetchUserFeatureAccess(
  featureKey: string,
  userId: string,
): Promise<UserFeatureAccess> {
  const res = await apiFetch<ApiResponse<UserFeatureAccess>>(userPath(featureKey, userId), {
    baseUrl: ADMIN_BASE_URL,
  })
  return res.data
}

export async function updateUserFeatureAccess(
  featureKey: string,
  userId: string,
  enabled: boolean,
  email?: string,
): Promise<UserFeatureAccess> {
  const payload: { enabled: boolean; email?: string } = { enabled }
  if (email !== undefined) payload.email = email
  const res = await apiFetch<ApiResponse<UserFeatureAccess>>(userPath(featureKey, userId), {
    baseUrl: ADMIN_BASE_URL,
    method: 'PUT',
    body: JSON.stringify(payload),
  })
  return res.data
}

export async function addFeatureAccessPersonByEmail(
  featureKey: string,
  email: string,
): Promise<UserFeatureAccess> {
  const res = await apiFetch<ApiResponse<UserFeatureAccess>>(`${featurePath(featureKey)}/users`, {
    baseUrl: ADMIN_BASE_URL,
    method: 'POST',
    body: JSON.stringify({ email }),
  })
  return res.data
}

// --------------------------------------------------------------------------- //
// #825 dilim 1: merkezi erişim haritası (henüz hiçbir sayfaya bağlı değil)
// --------------------------------------------------------------------------- //

const DATA_BASE_URL = '/api/data'

/** Kullanıcının tek bir özellik için sunucu kararı. */
export interface MyFeatureAccess {
  allowed: boolean
  outsider_view: FeatureAccessOutsiderView
}

export type MyFeatureAccessMap = Record<string, MyFeatureAccess>

/** Yönetim listesi satırı (kişi anahtarları dahil değil). */
export interface FeatureAccessListItem {
  featureKey: string
  kind: FeatureAccessKind
  label: string
  audience: FeatureAccessAudience
  outsiderView: FeatureAccessOutsiderView
}

export const MY_FEATURE_ACCESS_QUERY_KEY = ['feature-access', 'me'] as const
export const FEATURE_ACCESS_LIST_QUERY_KEY = ['admin', 'feature-access', 'list'] as const

/** GET /api/data/access/me — oturumdaki kullanıcının tüm özellikler için kararı. */
export async function fetchMyFeatureAccess(): Promise<MyFeatureAccessMap> {
  const res = await apiFetch<ApiResponse<{ features?: MyFeatureAccessMap }> | null>('/access/me', {
    baseUrl: DATA_BASE_URL,
  })
  return res?.data?.features ?? {}
}

/** GET /api/data/admin/feature-access — yalnız admin; tüm özellik satırları. */
export async function fetchFeatureAccessList(): Promise<FeatureAccessListItem[]> {
  const res = await apiFetch<ApiResponse<{ features?: FeatureAccessListItem[] }> | null>(
    '/feature-access',
    { baseUrl: ADMIN_BASE_URL },
  )
  return res?.data?.features ?? []
}

// --------------------------------------------------------------------------- //
// #979: arşiv — öğeyi yönetim listesinden gizler; erişim ayarına DOKUNMAZ
// --------------------------------------------------------------------------- //

export const FEATURE_ACCESS_ARCHIVE_QUERY_KEY = ['admin', 'feature-access', 'archive'] as const

/**
 * GET /api/data/admin/feature-access/archive — arşivlenmiş özellik anahtarları.
 * Gövde `{archived: [...]}`; uçların geri kalanı gibi `{data: {archived}}` ile sarılırsa o da okunur.
 */
export async function fetchFeatureAccessArchive(): Promise<string[]> {
  const res = await apiFetch<{ archived?: string[]; data?: { archived?: string[] } } | null>(
    '/feature-access/archive',
    { baseUrl: ADMIN_BASE_URL },
  )
  const list = res?.archived ?? res?.data?.archived
  return Array.isArray(list) ? list : []
}

/** PUT /api/data/admin/feature-access/archive/<key> — idempotent; yalnız arşiv işaretini yazar. */
export async function setFeatureAccessArchived(
  featureKey: string,
  archived: boolean,
): Promise<{ featureKey: string; archived: boolean }> {
  const res = await apiFetch<{ feature_key?: string; archived?: boolean; data?: { feature_key?: string; archived?: boolean } } | null>(
    `/feature-access/archive/${encodeURIComponent(featureKey)}`,
    { baseUrl: ADMIN_BASE_URL, method: 'PUT', body: JSON.stringify({ archived }) },
  )
  const body = res?.data ?? res
  return { featureKey: body?.feature_key ?? featureKey, archived: body?.archived ?? archived }
}
